// The app used to register the CRA service worker, which precached index.html and
// kept browsers on the previous version after each deploy. It no longer registers one:
// on every load it removes any registration and cache left by older versions.
// The build also replaces build/service-worker.js with a self-destroying worker
// (service-worker-killswitch.js) so tabs still running the old bundle clean up too.
export default function unregisterServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return Promise.resolve();
  }

  const unregisterAll = navigator.serviceWorker.getRegistrations()
    .then(registrations => Promise.all(registrations.map(registration => registration.unregister())));

  const clearCaches = window.caches
    ? window.caches.keys().then(keys => Promise.all(keys.map(key => window.caches.delete(key))))
    : Promise.resolve();

  return Promise.all([unregisterAll, clearCaches]).catch(error => {
    console.error('Error removing the service worker:', error);
  });
}
